<template>
    <li @click="submitPoll" class="tw-flex">
        <div class="mc-option tw-flex-1" :class="[{'chosen': answers.length > 0 && isSelected }, {'tw-opacity-50': storing_new_answer}, {'tw-mr-3': poll_settings.poll_public === '1'}, {'tw-pointer-events-none': (answers.length > 0 && poll_settings.retry !== '1' && !isSelected && option.id && poll_settings.poll_multiple_answers !== '1' || ended)}]" v-click-outside="hideMessages">

            <!--if it isn't an empty answer -->
            <template v-if="option.id">
                <!-- background meter -->
                <div class="mc-answer" :style="{ width: responseWidth + '%' }"></div>

                <!-- answer -->
                <i class="check-icon far fa-circle" :class="{'fa-dot-circle': answers.length > 0 && isSelected}"></i>
                <p v-html="option.value"></p>

                <!-- answer result in percentages -->
                <span v-if="answers.length > 0 || ended || poll_settings.poll_public === '1'">
                    {{ responseWidth.toFixed(2) }}%
                </span>

                <!-- submit message -->
                <transition name="animate-answer-submit">
                    <p class="message submit-message" v-if="show_confirm">
                        <i class="far fa-dot-circle tw-pr-4"></i>
                        {{ translations['poll.confirm_answer'] }}
                    </p>
                </transition>

                <!-- confirm delete message -->
                <transition name="animate-answer-submit">
                    <p class="message remove-message" v-if="show_remove_warning">
                        <i class="fa fa-times tw-pr-4"></i>
                        {{ translations['poll.confirm_delete_answer'] }}
                    </p>
                </transition>
            </template>

            <!-- empty answer -->
            <template v-else>
                <div class="tw-flex tw-items-center tw-w-full" @click="addNewAnswer">
                    <i class="check-icon far fa-plus"></i>
                    <p v-if="!adding_new_answer" class="empty-answer">{{ translations['poll.add_new_answer'] }}</p>
                    <input ref="newAnswer" v-else type="text" placeholder="" v-model="option.value" @keyup.enter="submitNewAnswer" @keyup.escape="resetNewAnswer" v-click-outside="submitNewAnswer">
                </div>
            </template>
        </div>

        <template v-if="poll_settings.poll_public === '1'">
            <div class="poll-option-user-preview-wrapper profile-icon-l tw-bg-black tw-overflow-hidden tw-relative tw-simple-hover" @click="showUsersThatVoted">
                <template v-if="usersThatVotedThisAnswer.length > 0">
                    <img class="tw-opacity-75" :src="usersThatVotedThisAnswer[0].avatar">
                    <p class="poll-option-user-preview tw-absolute tw-left-0 tw-right-0 tw-mx-auto tw-text-center tw-font-semibold tw-text-white tw-text-xl">
                        +{{ usersThatVotedThisAnswer.length }}
                    </p>
                </template>
                <template v-else>
                    <p class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-gray-200 tw-text-gray-500 tw-font-semibold tw-flex tw-items-center tw-justify-center">
                        0
                    </p>
                </template>
            </div>
        </template>
    </li>
</template>

<script>
    let _ = require('lodash');
    import vClickOutside from 'v-click-outside'
    import Global from '../../../mixins/Global.js'

    export default {
        mixins: [Global],
        name: "MultipleChoice",

        directives: {
            clickOutside: vClickOutside.directive
        },

        props: {
            question: {},
            poll: {},
            poll_settings: {},
            all_responses: {},
            answers: {},
            ended: {},
            option: {
                type: Object,
                default: () => {
                    return {
                        value: ''
                    }
                }
            },
        },

        data() {
            return {
                question_answer: [],
                responses_length: 0,
                given_answer: '',
                show_confirm: false,
                adding_new_answer: false,
                storing_new_answer: false,
                show_remove_warning: false,
            }
        },

        computed: {
            totalResponses() {
                let amount = 0;

                if(this.all_responses !== false && typeof this.all_responses !== 'undefined') {
                    for(let i = 0; i < this.all_responses.length; i++) {
                        amount += this.all_responses[i].number_of_responses;
                    }
                }

                return amount;
            },

            responseWidth() {
                if(this.answers.length > 0 || this.ended || this.poll_settings.poll_public === '1') {
                    let responses_for_option = this.$store.getters['poll/getResponsesForOptionById']({poll_id: this.poll.id, option_id: this.option.id});

                    //if the answer was just added then we don't have any responses for it
                    if(typeof responses_for_option !== 'undefined' && this.totalResponses > 0) {
                        return responses_for_option.number_of_responses / this.totalResponses * 100;
                    }
                }

                return 0;
            },

            usersThatVotedThisAnswer() {
                let users_for_option = this.$store.getters['poll/getUsersForOptionById']({poll_id: this.poll.id, option_id: this.option.id});

                //if the answer was just added then we don't have any responses for it
                if(typeof users_for_option !== 'undefined') {
                    return users_for_option.users;
                }

                return [];
            },

            isSelected() {
                let answers = this.answers.map(answer => answer.question_option_id);

                return answers.includes(this.option.id);
            }
        },

        methods: {
            submitPoll(){
                if(user && !this.ended) {
                    if((this.poll_settings.retry === '1' || this.answers.length === 0 || this.poll_settings.poll_multiple_answers === '1') && this.option.id && !this.isSelected) {
                        this.show_remove_warning = false;

                        if(!this.show_confirm) {
                            this.show_confirm = true;
                        } else {
                            this.show_confirm = false;

                            let formData = {
                                'quiz_id': this.poll.id,
                                'user_id': user.id,
                                'responses': [
                                    {
                                        'question_id': this.question.id,
                                        'question_option_id': this.option.id,
                                        'answer': this.option.id,
                                    }
                                ]
                            };

                            //if multiple answers are allowed, we send the already saved ones along so they don't get removed
                            if(this.poll_settings.poll_multiple_answers === '1') {
                                for(let i = 0; i < this.answers.length; i++) {
                                    formData.responses.push(
                                        {
                                            'question_id': this.question.id,
                                            'question_option_id': this.answers[i].question_option_id,
                                            'answer': this.answers[i].question_option_id,
                                        }
                                    )
                                }
                            }

                            //if we already had an answer, get its reponse_id so we can reuse it
                            if(this.answers.length > 0) {
                                formData.response_id = this.answers[0].response_id;
                            }

                            this.given_answer = this.option.id;

                            this.$store.dispatch('poll/postAnswer', formData).then((response) => {
                                this.$store.dispatch('poll/getCurrentProgress', response.data.data.response_id);
                                this.$store.dispatch('poll/getUserResponses', this.poll.id).then(() => {
                                    this.$emit('submit');
                                });
                            }).catch(() => {
                                this.$emit('timePassed');
                            });
                        }
                    } else if(this.isSelected && (this.poll_settings.retry === '1' || (this.poll_settings.retry === '0' && this.poll_settings.poll_multiple_answers === '1' && this.answers.length > 1))) {
                        this.show_confirm = false;
                        
                        if(!this.show_remove_warning) {
                            this.show_remove_warning = true;
                        } else {
                            this.show_remove_warning = false;
                            const user_response_id = this.$store.getters['poll/getUserResponseByAnswerId']({poll_id: this.poll.id, question_option_id: this.option.id});
                            const foundAnswer = this.answers.find(answer => answer.question_option_id === this.option.id);

                            this.$store.dispatch('poll/deleteUserResponses', user_response_id).then(() => {
                                this.$store.dispatch('poll/getCurrentProgress', foundAnswer.response_id);
                                this.$store.dispatch('poll/getUserResponses', this.poll.id).then(() => {
                                    this.$emit('submit');
                                });
                            });
                        }
                    }
                }
            },

            hideMessages() {
                this.show_confirm = false;
                this.show_remove_warning = false;
            },

            addNewAnswer() {
                this.adding_new_answer = true;

                this.$nextTick(() => {
                    this.$refs.newAnswer.focus();
                });
            },

            //save new answer
            submitNewAnswer() {
                if(user) {
                    if(this.adding_new_answer && !this.storing_new_answer) {
                        //prevent from storing the new answer twice
                        this.storing_new_answer = true;

                        //don't store the new option if there is no input
                        if(this.option.value === '') {
                            this.resetNewAnswer();
                        } else {
                            //prepare the new option for backend storing
                            let question = {
                                id: this.question.id,
                                question_options: [
                                    {
                                        question_id: this.question.id,
                                        value: this.option.value,
                                    }
                                ]
                            };

                            //store new option
                            this.$store.dispatch('storePollQuestionOptions', question).then((created_option) => {
                                //add the new option to the list of options
                                this.poll.questions[0].question_options.push(created_option);

                                //expand the poll answer overview
                                this.$emit('questionAdded');

                                //reset new answer to base values
                                this.resetNewAnswer();

                                //activate new option again
                                this.adding_new_answer = true;

                                //focus the input again
                                this.$nextTick(() => {
                                    this.$refs.newAnswer.focus();
                                });
                            });
                        }
                    }
                }
            },

            //reset new answer option
            resetNewAnswer() {
                this.option.value = '';
                this.adding_new_answer = false;
                this.storing_new_answer = false;
            },

            showUsersThatVoted() {
                if(this.usersThatVotedThisAnswer.length > 0) {
                    //set delete topic modal data
                    this.$store.commit('setModalData', {
                        modalName: 'PollAnswerUsers',
                        modalData: {
                            topContent: this.translations['poll.votes_for'] + ': ' + this.option.value,
                            icon: 'fa fa-users',
                            users: this.usersThatVotedThisAnswer,
                        },
                        showModalButtons: false,
                    });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .all-questions{
        @apply tw-mt-8;

        .mc-option {
            @apply tw-relative tw-flex tw-overflow-hidden tw-mb-4 tw-cursor-pointer tw-mb-4 tw-p-4 tw-items-center;
            border-radius: 0.5rem !important;
            box-shadow: 0px 1px 2px 1px #e6e4e4;

            .mc-answer {
                @apply tw-absolute tw-h-full tw-left-0 tw-top-0 tw-flex tw-items-center tw-justify-center tw-text-2xl tw-font-semibold tw-bg-gray-0;
                transition: width 0.2s ease;
            }

            p {
                @apply tw-flex-1 tw-text-gray-600 tw-text-base tw-flex tw-items-center tw-font-semibold tw-z-10 tw-mb-0;
                padding-left: 0.6rem;

                &.empty-answer {
                    @apply tw-text-gray-400;
                }
            }

            input {
                @apply tw-w-full;
                border: none;
                padding: 2px;
                padding-left: 10px;
                margin-bottom: 0 !important;
                color: #8e8e8e;
                font-size: 1rem;
                font-weight: 600;

                &:focus {
                    outline: none;
                }
            }

            .check-icon {
                @apply tw-z-10 tw-text-gray-500;
            }

            .message {
                @apply tw-absolute tw-left-0 tw-right-0 tw-mx-auto tw-justify-center tw-text-white tw-font-bold tw-pl-0 tw-text-sm;
                border-radius: 0.5rem !important;
                width: 240px;
                height: 25px;
                top: 15px;

                &.submit-message {
                    @apply tw-bg-green-500;
                }

                &.remove-message {
                    @apply tw-bg-red-500;
                }
            }

            span {
                @apply tw-font-bold tw-text-gray-500;
                z-index: 1;
            }

            &:hover {
                @apply tw-opacity-75;

                &:not(.chosen) {
                    .mc-answer {
                        width: 15px !important;
                    }
                }
            }

            &.chosen {
                box-shadow: 0px 0px 2px 2px #e0e0e0;

                .mc-answer {
                    @apply tw-bg-green-200;
                }

                span {
                    @apply tw-text-green-600;
                }
            }
        }

        .profile-icon-l {
            display: inline-block;
            position: relative;
            width: 56px;
            height: 56px;

            img {
                width: 56px;
                height: 56px;
                border-radius: 100% !important;
            }
        }

        .poll-option-user-preview-wrapper {
            border-radius: 100% !important;

            .poll-option-user-preview {
                top: 13px;
                text-shadow: 0 2px 4px rgba(0,0,0,0.50);
            }
        }

        .animate-answer-submit-enter-active {
            transition: top 0.15s ease-out, opacity 0.15s ease-out;
        }

        .animate-answer-submit-enter {
            top: 45px !important;
        }

        .animate-answer-submit-enter-to {
            top: 12px !important;
        }
    }
</style>